import {pluralize} from "@pg-mono/string-utils";

import {IHouseInvestmentBooster} from "../../types/booster_generic/IHouseInvestmentBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {getOfferStatsByArea} from "../../utils/offer_stats/get_offer_stats_by_area";
import {getLastHousePropertyWithCountingText} from "../../utils/texts/last_property_text";

export const houseInvestmentAreaBooster: IHouseInvestmentBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Area,

    isValid(params) {
        const areaUpper = Number(params.userPref?.filters?.area_1);
        return !!getOfferStatsByArea(areaUpper, params.offer.stats?.building_parameters_stats);
    },

    getSegments(params) {
        const areaUpper = Number(params.userPref?.filters?.area_1);
        const stats = getOfferStatsByArea(areaUpper, params.offer.stats?.building_parameters_stats);

        if (!stats || !stats.left || !stats.label) {
            return null;
        }

        const leftTextPluralize = pluralize(["został", "zostały", "zostało"])(stats.left);

        return [
            "Złap okazję! W tej inwestycji",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${leftTextPluralize} ${getLastHousePropertyWithCountingText(stats.left)}`
            },
            `o metrażu ${stats.label}.`
        ];
    }
};
import {pluralize} from "@pg-mono/string-utils";

import {IHouseInvestmentBooster} from "../../types/booster_generic/IHouseInvestmentBooster";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterOfferStatsType} from "../../types/IBoosterOfferStatsType";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";
import {getOfferStatsByArea} from "../../utils/offer_stats/get_offer_stats_by_area";
import {getLastHousePropertyWithCountingText} from "../../utils/texts/last_property_text";

export const houseInvestmentAreaBooster: IHouseInvestmentBooster = {
    category: IBoosterCategory.OfferStats,
    type: IBoosterOfferStatsType.Area,

    isValid(params) {
        const areaUpper = Number(params.userPref?.filters?.area_1);
        return !!getOfferStatsByArea(areaUpper, params.offer.stats?.building_parameters_stats);
    },

    getSegments(params) {
        const areaUpper = Number(params.userPref?.filters?.area_1);
        const stats = getOfferStatsByArea(areaUpper, params.offer.stats?.building_parameters_stats);

        if (!stats || !stats.left || !stats.label) {
            return null;
        }

        const leftTextPluralize = pluralize(["został", "zostały", "zostało"])(stats.left);

        return [
            "Złap okazję! W tej inwestycji",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: `${leftTextPluralize} ${getLastHousePropertyWithCountingText(stats.left)}`
            },
            `o metrażu ${stats.label}.`
        ];
    }
};
